import { TrendingUp, TrendingDown, FileText, Target, Award, Flame } from 'lucide-react'

export default function WeeklyReport({ data }) {
    // Use passed data or default to zeros
    const report = data || {
        dateRange: getDateRange(),
        summary: {
            wordsAnalyzed: 0,
            wordsChange: 0,
            clichesFound: 0,
            clichesChange: 0,
            suggestionsUsed: 0,
            avgScore: 0,
        },
        streak: 0,
        topImprovement: 'Start writing to see improvements',
        topCliche: 'No data yet',
    }

    function getDateRange() {
        const end = new Date()
        const start = new Date(end.getTime() - 7 * 24 * 60 * 60 * 1000)
        return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
    }

    return (
        <div className="glass-card p-6">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h3 className="text-lg font-semibold text-white">Weekly Report</h3>
                    <p className="text-sm text-white/50">{report.dateRange}</p>
                </div>
                <button className="btn-ghost text-sm">
                    View Full Report
                </button>
            </div>

            {/* Summary Stats */}
            <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="p-4 rounded-xl bg-white/5">
                    <div className="flex items-center gap-2 mb-2">
                        <FileText className="w-4 h-4 text-primary-400" />
                        <span className="text-sm text-white/60">Words Analyzed</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-2xl font-bold text-white">
                            {report.summary.wordsAnalyzed.toLocaleString()}
                        </span>
                        <span className={`text-sm flex items-center gap-1 ${report.summary.wordsChange >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                            {report.summary.wordsChange >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                            {report.summary.wordsChange >= 0 ? '+' : ''}{report.summary.wordsChange}%
                        </span>
                    </div>
                </div>

                <div className="p-4 rounded-xl bg-white/5">
                    <div className="flex items-center gap-2 mb-2">
                        <Target className="w-4 h-4 text-accent-400" />
                        <span className="text-sm text-white/60">Clichés Found</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-2xl font-bold text-white">
                            {report.summary.clichesFound}
                        </span>
                        <span className={`text-sm flex items-center gap-1 ${report.summary.clichesChange <= 0 ? 'text-green-400' : 'text-red-400'}`}>
                            {report.summary.clichesChange <= 0 ? <TrendingDown className="w-3 h-3" /> : <TrendingUp className="w-3 h-3" />}
                            {report.summary.clichesChange}%
                        </span>
                    </div>
                </div>
            </div>

            {/* Streak and Score */}
            <div className="flex items-center gap-4 p-4 rounded-xl bg-gradient-to-r from-primary-500/10 to-accent-500/10 border border-primary-500/20 mb-6">
                <div className="flex items-center gap-3 px-4 py-2 rounded-lg bg-white/5">
                    <Flame className="w-6 h-6 text-orange-400" />
                    <div>
                        <div className="text-2xl font-bold text-white">{report.streak}</div>
                        <div className="text-xs text-white/50">Day Streak</div>
                    </div>
                </div>
                <div className="flex-grow">
                    <div className="flex items-center gap-2 mb-1">
                        <Award className="w-4 h-4 text-yellow-400" />
                        <span className="text-sm font-medium text-white">Top Improvement</span>
                    </div>
                    <p className="text-sm text-white/60">{report.topImprovement}</p>
                </div>
            </div>

            {/* Quick Insights */}
            <div className="space-y-3">
                <div className="flex items-center justify-between py-2 border-b border-white/5">
                    <span className="text-sm text-white/60">Suggestions Applied</span>
                    <span className="text-sm font-medium text-white">
                        {report.summary.suggestionsUsed} of {report.summary.clichesFound}
                        <span className="text-white/40 ml-1">
                            ({report.summary.clichesFound > 0 ? Math.round((report.summary.suggestionsUsed / report.summary.clichesFound) * 100) : 0}%)
                        </span>
                    </span>
                </div>
                <div className="flex items-center justify-between py-2 border-b border-white/5">
                    <span className="text-sm text-white/60">Average Quality Score</span>
                    <span className="text-sm font-medium gradient-text">{report.summary.avgScore}/100</span>
                </div>
                <div className="flex items-center justify-between py-2">
                    <span className="text-sm text-white/60">Most Used Cliché</span>
                    <span className="text-sm font-medium text-yellow-400">{report.topCliche}</span>
                </div>
            </div>
        </div>
    )
}
